import { render } from "./BootstrapModal.vue?vue&type=template&id=852807d2&scoped=true"
import script from "./BootstrapModal.vue?vue&type=script&lang=js"
export * from "./BootstrapModal.vue?vue&type=script&lang=js"

import "./BootstrapModal.vue?vue&type=style&index=0&id=852807d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852807d2"]])

export default __exports__